// /invoices/$id szegmens layout-ja — CSAK <Outlet/>. A lapok a gyerek-route-okban: `invoices.$id.index`
// (read-only részlet) és `invoices.$id.edit` (piszkozat-szerkesztő).
//
// MIÉRT KELL: a fájl-alapú routing a `/invoices/$id/edit`-et a `$id` szegmens Outlet-jébe rendeli. Amíg a
// RÉSZLET volt a `$id` komponense (Outlet nélkül), a `/edit` URL-en a felület a read-only részletet mutatta —
// a szerkesztő sosem renderelt. Ugyanaz a hiba-osztály, mint a szegmens-szinten (lásd `invoices.tsx`).
// Az auth-guard a SZÜLŐ (`/invoices`) layouton van, itt nem duplikáljuk.
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/invoices/$id')({
  component: InvoiceIdLayout,
});

function InvoiceIdLayout(): JSX.Element {
  return <Outlet />;
}
